import React, { useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Home from "./Componets/Pages/Home/Index";
import Profile from "./Componets/Pages/Profile/Profile";
import Employee from "./Componets/Pages/Employee/Employee";
import Notification from "./Componets/Pages/Notification/Notification";
import MeatalPriceUpdate from "./Componets/Pages/MetalPriceUpdate/MeatalPriceUpdate";
import TopReports from "./Componets/Pages/TopReports/TopReports";
import HomeTab from "./Componets/Pages/HomeTab";
import Cookies from "js-cookie";
import SalesReport from "./Componets/Pages/Reports/SalesReport/SalesReport";
import OrderReport from "./Componets/Pages/Reports/OrderReport/OrderReport";
import StockReport from "./Componets/Pages/Reports/StockReport/StockReport";
import WipReport from "./Componets/Pages/Reports/WipReport/WipReport";
import LossReport from "./Componets/Pages/Reports/LossReport/LossReport";
import InfoReport from "./Componets/Pages/Reports/InfoReport/InfoReport";
import SupportCenter from "./Componets/Pages/SupportCenter/SupportCenter";
import PrivacyPolicy from "./Componets/Pages/PrivacyPolicy/PrivacyPolicy ";
import { useRecoilValue } from "recoil";
import { menuDrawer } from "./Componets/Recoil/atom";
import AccountDeleteStep from "./Componets/Pages/AccountDeleteStep/AccountDeleteStep";
import LiquidityTracker from "./Componets/Pages/LiquidityTracker/LiquidityTracker";
import TvConnect from "./Componets/Pages/Tvconnect/TvConnect";
import DevicesSet from "./Componets/Pages/Tvconnect/DevicesSet/DevicesSet";
import IpAddressManagement from "./Componets/Pages/IpAddressManagement/IpAddressManagement";
import SampleReport from "./Componets/Pages/Reports/SampleReport/SampleReport";
import LedgerDetail from "./Componets/Pages/Reports/SampleReport/Deatil/LedgerDetail";
import LedgerMoreDetail from "./Componets/Pages/Reports/SampleReport/Deatil/moreDeatail/LedgerMoreDetail";

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const drawerMenu = useRecoilValue(menuDrawer);

  // const queryParams = new URLSearchParams(window.location.search);
  // const redirectUrl = queryParams.get("redirectUrl");
  // http://localhost:3000/?device_token=U015UW9PV4JY9S9A&Token=LGN103D12R6A17HG4CAI&SV=0

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const device_token = queryParams.get("device_token");
    const token = queryParams.get("token");
    const SV = queryParams.get("SV");
    const redirectUrl = queryParams.get("redirectUrl");

    if (device_token !== undefined && SV !== null && token !== null) {
      sessionStorage.setItem("device_token", device_token);
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("SV", SV);
      sessionStorage.setItem("isLogin", true);

      Cookies.set("device_token", device_token);
      Cookies.set("token", token);
      Cookies.set("SV", SV);
    }

    if (redirectUrl) {
      navigate(redirectUrl);
    }
  }, [navigate]);

  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/employee" element={<Employee />} />
        <Route path="/Notification" element={<Notification />} />
        <Route path="/SalesReport" element={<SalesReport />} />
        <Route path="/OrderReport" element={<OrderReport />} />
        <Route path="/StockReport" element={<StockReport />} />
        <Route path="/MeatalPriceUpdate" element={<MeatalPriceUpdate />} />
        <Route path="/TopReports" element={<TopReports />} />
        <Route path="/WipReport" element={<WipReport />} />
        <Route path="/LossReport" element={<LossReport />} />
        <Route path="/InfoReport" element={<InfoReport />} />
        <Route path="/SampleReport" element={<SampleReport />} />
        <Route path="/LedgerDetail" element={<LedgerDetail />} />
        <Route path="/support" element={<SupportCenter />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/steps-account-delete" element={<AccountDeleteStep />} />
        <Route path="/LiquidityTracker" element={<LiquidityTracker />} />
        <Route path="/TvConnect" element={<TvConnect />} />
        <Route path="/DevicesSet" element={<DevicesSet />} />
        <Route path="/IpAddressManagement" element={<IpAddressManagement />} />
        <Route path="/LedgerMoreDetail" element={<LedgerMoreDetail />} />
      </Routes>
      {location.pathname == "/profile" ||
      location.pathname == "/OrderReport" ||
      location.pathname == "/StockReport" ||
      location.pathname == "/Notification" ||
      location.pathname == "/MeatalPriceUpdate" ||
      location.pathname == "/support" ||
      location.pathname == "/TopReports" ||
      location.pathname == "/privacy-policy" ||
      location.pathname == "/employee" ||
      location.pathname === "/SalesReport" ||
      location.pathname === "/WipReport" ||
      location.pathname === "/LossReport" ||
      location.pathname === "/InfoReport" ||
      location.pathname === "/SampleReport" ||
      location.pathname === "/DevicesSet" ||
      location.pathname === "/LedgerDetail" ||
      location.pathname === "/LedgerMoreDetail" ||
      location.pathname === "/steps-account-delete" ||
      drawerMenu ? (
        ""
      ) : (
        <HomeTab />
      )}
    </div>
  );
};

export default App;



// import React, { useEffect } from "react";
// import { BrowserRouter, Route, Routes } from "react-router-dom";
// import Home from "./Componets/Pages/Home/Index";
// import Profile from "./Componets/Pages/Profile/Profile";
// import Employee from "./Componets/Pages/Employee/Employee";
// import Notification from "./Componets/Pages/Notification/Notification";
// import MeatalPriceUpdate from "./Componets/Pages/MetalPriceUpdate/MeatalPriceUpdate";
// import TopReports from "./Componets/Pages/TopReports/TopReports";
// import HomeTab from "./Componets/Pages/HomeTab";
// import Cookies from "js-cookie";

// // 'https://testr1.optigoapps.com/welcome?deviceid={deviceid}&device_token={deviceToken}&logintypename={logintypename}&logintypeid={logintypeid}&admin_appid=1&adminapp_domainname={adminappDomainname}&SV={"1"}&token={TOKEN}'
// const App = () => {
//   useEffect(() => {
//     const queryParams = new URLSearchParams(window.location.search);
//     const device_token = queryParams.get("device_token");
//     const token = queryParams.get("token");
//     const SV = queryParams.get("SV");

//     if (device_token !== undefined && SV !== null && token !== null) {

//       sessionStorage.setItem("device_token", device_token);
//       sessionStorage.setItem("token", token);
//       sessionStorage.setItem("SV", SV);
//       sessionStorage.setItem("isLogin", true);

//       Cookies.set("device_token", device_token);
//       Cookies.set("token", token);
//       Cookies.set("SV", SV);
//       Cookies.set("isLogin", true);
//     }
//   }, []);

//   // Cookies.remove('name')

//   return (
//     // "homepage": "/adminapp",
//     // <BrowserRouter basename="/adminapp">

//     <BrowserRouter>
//       <Routes>
//         <Route path="/home" element={<Home />} />
//         <Route path="/profile" element={<Profile />} />
//         <Route path="/employee" element={<Employee />} />
//         <Route path="/Notification" element={<Notification />} />
//         <Route path="/MeatalPriceUpdate" element={<MeatalPriceUpdate />} />
//         <Route path="/TopReports" element={<TopReports />} />
//       </Routes>
//       <HomeTab />
//     </BrowserRouter>
//   );
// };

// export default App;
